import { useTranslations } from '@vocab/react';
import { Stack, Text } from 'braid-design-system';
import type { FC } from 'react';

import { SmallDisclosure } from 'src/libs/SmallDisclosure/SmallDisclosure';

import { VerifiedBySeekPassIcon } from '../../VerifiedBySeekPassIcon';
import { ProfileDetails } from '../ProfileDetails';
import { TextDisclosureWithLinks } from '../TextDisclosureWithLinks';

import translations from './.vocab';

interface LicenceProps {
  id: string;
  title: string;
  issuingOrganisation: string | null;
  formattedDate: string | null;
  description: string | null;
  verificationViewFields: Array<{ name: string; values: string[] }> | undefined;
}

export const Licence: FC<LicenceProps> = ({
  id,
  title,
  issuingOrganisation,
  formattedDate,
  description,
  verificationViewFields,
}) => {
  const { t } = useTranslations(translations);
  const isVerified =
    verificationViewFields && verificationViewFields.length > 0;
  return (
    <Stack space="small">
      {isVerified ? (
        <VerifiedBySeekPassIcon id={id} title={title} />
      ) : (
        <Text weight="strong">{title}</Text>
      )}

      {issuingOrganisation ? (
        <Text size="small">{issuingOrganisation}</Text>
      ) : null}
      {formattedDate ? (
        <Text size="small" tone="secondary">
          {formattedDate}
        </Text>
      ) : null}
      {description ? (
        <TextDisclosureWithLinks
          text={description}
          linesToPreview={3}
          size="small"
        />
      ) : null}
      {isVerified ? (
        <SmallDisclosure
          id={id}
          expandLabel={t('Show verification details')}
          collapseLabel={t('Hide verification details')}
          weight="weak"
        >
          <ProfileDetails details={verificationViewFields} />
        </SmallDisclosure>
      ) : null}
    </Stack>
  );
};
